import Florists from './Florists';
import Chiropractors from './Chiropractors';
import CarpetCleaning from './CarpetCleaning';
import Builders from './Builders';
import DoctorsMedicalCentres from './DoctorsMedicalCentres';
import SolarPowerSystems from './SolarPowerSystems';
import Podiatrists from './Podiatrists';
import Locksmiths from './Locksmiths';
import Dentists from './Dentists';
import Physiotherapists from './Physiotherapists';
import KitchenRenovations from './KitchenRenovations';
import PestControl from './PestControl';
import Electricians from './Electricians';
import Tyres from './Tyres';
import CosmeticSkinClinics from './CosmeticSkinClinics';
import Plumbers from './Plumbers';

export default {
  Florists,
  Chiropractors,
  'Carpet Cleaning': CarpetCleaning,
  'Doctors & Medical Centres': DoctorsMedicalCentres,
  Builders,
  'Solar Power Systems': SolarPowerSystems,
  Podiatrists,
  Locksmiths,
  Dentists,
  Physiotherapists,
  Electricians,
  'Kitchen Renovations & Designers': KitchenRenovations,
  'Pest Control': PestControl,
  'Cosmetic & Skin Clinics': CosmeticSkinClinics,
  Tyres,
  Plumbers,
};
